import { render, staticRenderFns } from "./TransferEdit.vue?vue&type=template&id=56d0d5c8&scoped=true&"
import script from "./TransferEdit.vue?vue&type=script&lang=js&"
export * from "./TransferEdit.vue?vue&type=script&lang=js&"
import style0 from "./TransferEdit.vue?vue&type=style&index=0&id=56d0d5c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d0d5c8",
  null
  
)

export default component.exports